import { snakeCaseToWords } from "../../utility";
import { closeModalRoute } from "../modal/modal.mixin";
import { createAdvancedSearchConfig } from "./advanced-search.model";
import SearchConBadge from "./search-con-badge";

export const createAdvancedSearchHost = (advancedSearchConfig = createAdvancedSearchConfig(), {
  fetchListMethodName = 'fetchListReset',
  onAfterAdvancedSearchFetch = '',
  onBeforeAdvancedSearchFetch = ''
} = {}) => {
  return {
    components: {
      SearchConBadge
    },
    data: function () {
      return {
        searchFilter: {},
      }
    },
    computed: {
      filteredAdvancedSearchConfigKeys: function () {
        // console.log(advancedSearchConfig.advancedSearchConfigKeys.filter((e) =>
        //   this.searchFilterValue(e)
        // ));
        return advancedSearchConfig.advancedSearchConfigKeys.filter((e) =>
          this.searchFilterValue(e)
        );
      },
      searchConBadgeExists: function () {
        return this.filteredAdvancedSearchConfigKeys?.length > 0;
      }
    },
    methods: {
      resetSearchFilter: function () {
        this.searchFilter = {};
        console.log({'advance-search.mixin.js:36 this.searchFilter' : this.searchFilter});
      },
      onAdvancedSearch: async function (payload) {
        this.searchFilter = payload;
        // console.log({ "this.searchFilter": this.searchFilter });

        // Resetting Basic Filter before Advanced Searching 
        if (this.resetBasicFilter) {
          this.resetBasicFilter();
        }

        if (onBeforeAdvancedSearchFetch) {
          this[onBeforeAdvancedSearchFetch]();
        }
        await this[fetchListMethodName]();
        if (onAfterAdvancedSearchFetch) {
          this[onAfterAdvancedSearchFetch]();
        }
        this.onAdvancedSearchCancelled();
      },
      searchFilterValue: function (key) {
        // console.log({
        //   "this.searchFilter[key]": this.searchFilter[key], key,
        //   "advancedSearchConfig.isBooleanSearchKey(key)": advancedSearchConfig.isBooleanSearchKey(key),
        //   advancedSearchConfigKeys: advancedSearchConfig.advancedSearchConfigKeys
        // });
        if (advancedSearchConfig.isOmitKey(key)) {
          // console.log({ "isADVSearchOmit(key)": advancedSearchConfig.isOmitKey(key), key });
          const omitTargetKey = advancedSearchConfig.findADVSearchKeyFromOmit(key);

          const filterValue = this.searchFilter[key];
          const targetValue = this.searchFilter[omitTargetKey];
          // console.log({ "filterValue": targetValue });

          if (targetValue) {
            return false;
          } else if (filterValue && !targetValue) {
            return snakeCaseToWords(key);
          }

          return false;
        } else if (advancedSearchConfig.isTVKey(key)) {
          const filterValue = this.searchFilter[key];

          const tvKey = advancedSearchConfig.findTVKey(key);
          const selected = this?.advancedSearchData?.[tvKey].find(
            (e) => e.value == filterValue
          );
          return filterValue && selected ? selected.text : false;
        } else if (advancedSearchConfig.isMulTVValueKey(key)) {
          const filterValue = this.searchFilter[key]?.split(',') || [];
          const tvArrayKey = advancedSearchConfig.findMulTVArrayKey(key);
          const selecteds = this?.advancedSearchData?.[tvArrayKey].filter(
            (e) => filterValue.includes(e?.value?.toString())
          );

          return filterValue && selecteds ? selecteds.map(e => e.text).join(', ') : false;

        } else if (advancedSearchConfig.isBooleanSearchKey(key)) {
          return this.searchFilter[key]
            ? advancedSearchConfig.booleanSearchLabel(key)
              ? advancedSearchConfig.booleanSearchLabel(key)
              : key
            : false;
        } else {
          return this.searchFilter[key]
            ? this.searchFilter[key]
            : false;
        }
      },
      searchConfigKey: function (key) {
        return {
          value: this.searchFilterValue(key),
          searchKey: key,
          isOmitted: this.isSearchKeyOmitted(key),
        };
      },
      isSearchKeyOmitted: function (key) {

        if (advancedSearchConfig.isOmitKey(key)) {
          const omitTargetKey = advancedSearchConfig.findADVSearchKeyFromOmit(key);

          const filterValue = this.searchFilter[key];
          const targetValue = this.searchFilter[omitTargetKey];
          if (filterValue && !targetValue) {
            return true;
          }
        } else {
          return this.searchFilter[`${key}_missing`] &&
            this.searchFilter[`${key}_missing`] == 1
            ? true
            : false;
        }


      },
      onAdvancedSearchCancelled: function () {
        closeModalRoute(this);
      },
      onSearchConDelete: function (key) {
        const omitKey = advancedSearchConfig.findADVSearchOmitFromKey(key);

        this.searchFilter = {
          ...this.searchFilter,
          [key]: "",
          ...(omitKey ? { [omitKey]: "" } : {}),
        };

        this[fetchListMethodName]();
      },

      onBeforeAdvancedSearchFetch: function () {
        if (this.resetBasicFilter) {
          this.resetBasicFilter();
        }
      },
    },
  }
}


export const createAdvancedSearchModal = (advancedSearchConfig) => {
  // console.log({ "advancedSearchConfig": advancedSearchConfig });
  return {
    props: {
      advancedSearchData: {
        type: Object,
      },
      initSearchFilter: {
        required: true,
        type: Object,
        default: () => { },
      },
    },
    mounted() {

    },
    watch: {
      initSearchFilter: {
        immediate: true,
        handler: function (to, from) {
          if (!to) {
            return;
          }
          // console.log({ 'advance-search.mixin.js:171 advancedSearchConfig': advancedSearchConfig });
          advancedSearchConfig.advancedSearchConfigKeys?.filter(x => x != '')?.map(
            (key) => {
              // console.log({key, 'this[key]' : this[key], tk: to[key], to});
              this[key] = to[key];
            }
          );
          advancedSearchConfig.booleanSearchKeys.map(
            (key) => {
              this[key] = to[key];
            }
          );
        },
      },
    },
    computed: {
      // searchFilter() {
      //   const no_filter_selected =
      //   advancedSearchConfig.advancedSearchConfigKeys.every(
      //     (e) => !this[e]
      //   );
      //   return {
      //     no_filter_selected,
      //     ...ensureStringObjectFromKeys(
      //       this,
      //       advancedSearchConfig.searchConfigStringKeys
      //     ),
      //     ...ensureBoolIntObjectFromKeys(
      //       this,
      //       advancedSearchConfig.booleanSearchKeys
      //     ),
      //     ...ensureBoolIntObjectFromKeys(
      //       this,
      //       advancedSearchConfig.searchConfigIntKeys
      //     ),
      //   };
      // }
    }
  }
}